export const copy = {
  scrambleGlyphs: "创意设计交互三维动态光影探索",
  play: "播放",
  pause: "暂停",
  mute: "静音",
  unmute: "开启声音",
  reelLabel: "Lusion 作品短片",
  emailInvalid: "请输入有效的邮箱地址。",
  newsletterPreview: "感谢关注！当前为体验页面，可前往原站订阅灵感来信。",
  backToTop: "回到首页",
};
